import { styled } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import backgroundLogin from '../../assets/background-login.png';
import loginImg from '../../assets/illustration-login.png';
import logo from '../../assets/mtlawllc-logo-header.png';
import logo2 from '../../assets/mtlawllc-logo-login.png';
import avatar from '../../assets/icon-user.png';

export const Root = styled(Box)({
    height: '100vh',
    background: `url(${backgroundLogin}) no-repeat center top/cover`,
    '& .logo': {
        width: '187px',
        height: '43px',
        background: `url(${logo}) no-repeat center top/cover`,
    },
    '& .loginWapper': {
        width: '960px',
        height: '409px',
        backgroundColor: '#fff',
        boxShadow: '0px 0px 5px 1px rgba(0,0,0,0.2)',
        '& .leftWapper': {
            width: '50%',
            height: '100%',
            padding: '0 32px',
            position: 'relative',
            '& .avatars': {
                width: '69px',
                height: '69px',
                top: '-34px',
                borderRadius: '3px',
                position: 'absolute',
                background: `url(${avatar}) no-repeat center top/cover`,
            },
            '& .title': {
                fontSize: '24px',
                fontWeight: 'bold',
                margin: '34px 0',
            },
            '& .textWapper': {
                '& .t2': {
                    margin: '16px 0',
                },
            },
            '& .line': {
                width: '100%',
                height: '1px',
                margin: '16px 0',
                backgroundColor: '#D8D8D8',
            },
            '& .logoWapper': {
                width: '100%',
                '& .logo2': {
                    width: '158px',
                    height: '36px',
                    background: `url(${logo2}) no-repeat center top/cover`,
                },
            },
        },
        '& .rightWapper': {
            width: '50%',
            height: '100%',
            backgroundColor: '#005e96',
            '& .loginImg': {
                width: '409px',
                height: '409px',
                background: `url(${loginImg}) no-repeat center top/cover`,
            },
        }
    }
});